/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "schedules",
	init: init,
	triggers: triggers,
	listeners: listeners,

	_language: "en",
	_localization: {},
	_modify: false,
	_sorted: [], // sorted array of cron tasks in cron syntax
	_loaded: false,
	translate_from_cron: translate_from_cron,
	translate_to_cron: translate_to_cron,
	handle_schedule: handle_schedule,
	handle_modify: handle_modify,
	handle_add: handle_add,
	handle_remove: handle_remove,
	handle_clear: handle_clear,
	handle_new_task: handle_new_task,
	handle_remove_task: handle_remove_task,
	refresh_schedule: refresh_schedule,
});

var day_names = [
	"sun",
	"mon",
	"tue",
	"wed",
	"thu",
	"fri",
	"sat"
];

function init() {
	var modify = this._modify;
	var readable = [];
	this.extend({
		modify: modify,
		readable: readable
	});
	// fetch any existing schedules
	this.refresh_schedule();
}

function triggers() {
	/**
	 * add a task
	 * delete a task
	 * clear all tasks
	 */
	return {
		view: handle_view,
		modify: handle_modify,
		add: handle_add,
		remove: handle_remove,
		clear: handle_clear,
	};
}

function handle_view() {
	this._loaded = true;
	this.refresh_schedule();
}

function listeners() {
	return {
		"connectivity:online": refresh_schedule,
		"localization:updated": handle_language,
		"mqtt:$/schedule/added": handle_new_task,
		"mqtt:$/schedule/removed": handle_remove_task,
	};
}

function handle_new_task(data) {
	var action = data.action;
	var cron = data.cron;
	var timezone = data.timezone;
	this._sorted.push({
		action: action,
		cron: cron,
		timezone: timezone,
	});

	this.handle_schedule(this._sorted);
}

function handle_remove_task(data) {
	var action = data.action;
	var cron = data.cron;
	var filtered = this._sorted.filter(function (item) {
		return (item.action !== action || item.cron !== cron);
	});
	this.handle_schedule(filtered);
}

function handle_language(data) {
	this._language = data.language;
	this._localization = data.localization;
}

function handle_modify() {
	// toggles modify variable
	var new_state = !this._modify;
	this._modify = new_state;
	this.extend({
		modify: this._modify
	});
	this._modify && this.emit("usermetrics:trigger:track", "begin adding new status schedule to self");
}

function handle_add(data) {
	var action = data.action;
	var schedule = data.schedule;
	var timezone = data.timezone;
	var scheduleData = {
		action: action,
		schedule: schedule,
		timezone: timezone
	};

	if(!alreadyExists(this._sorted, scheduleData)){
		this.emit("usermetrics:trigger:track", "add new status schedule to self");
		this.api.schedule.add(scheduleData);
	}
	var message = "schedule.scheduleaddnew";
	this.emit("toast:trigger:show", {
		content: message,
	});

	this.emit("schedules:trigger:modify");
}

function alreadyExists(existing, scheduleData) {
	return existing.some(function(schedule){
		return (scheduleData.schedule === schedule.cron ) && (scheduleData.action === schedule.action) && (scheduleData.timezone === schedule.timezone);
	});
}

function handle_remove(data) {
	var action = data.action;
	var schedule = this.translate_to_cron(data.schedule);
	this.api.schedule.remove({
		action: action,
		schedule: schedule
	});

	var message = "schedule.scheduleremoved";
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});

	this.emit("usermetrics:trigger:track", "remove own status schedule");
}

function handle_clear() {
	this.api.schedule.reset();
	this.refresh_schedule();
	this.emit("usermetrics:trigger:track", "close schedules");
}

function refresh_schedule() {
	if(!this._loaded) return;
	//dbase call list
	return this.api.schedule.list()
		.then(extract)
		.then(handle_schedule.bind(this))
		.catch(console.error.bind(console));
}

function extract(data) {
	//take array and construct a schedule
	if(!data)return;
	var first = data[0];
	if(!first) return;
	var schedules = first.schedule;
	return schedules;
}

function handle_schedule(schedules) {
	// sort the schedules _before_ translating to human readable
	if(!schedules) return;

	var sorted = schedules.sort(sort_sched);
	var readable = sorted.map(function (task) {
		var action = task.action;
		var task_time = task.cron;
		var schedule = this.translate_from_cron(task_time);
		var item = {
			action: action,
			schedule: schedule
		};
		return item;
	}, this);
	this._sorted = sorted;
	this.extend({
		readable: readable
	});
}

function translate_from_cron(cron) {
	var data = {};
	var parts = cron.split(" ");
	var minutes = parts[0];
	var hours = parts[1];
	var days = parts[4];
	var dayOfMonth = parts[2];
	var month = parts[3] || "*";
	var dayKey = day_names[days];

	var options = {
		weekday: "short",
		month: "short",
		day: "2-digit"
	};

	data.days = this.config.localization[this._language].ae_schedule_days[dayKey];
	data.minutes = fill(minutes);
	data.hours = fill(hours);
	data.schedule_hour = hours;
	data.schedule_minute = minutes;

	var date = null;

	var locale = this._language;
	if(locale === "cn_s")
		locale = "zh-CN";
	else if(locale === "cn_t")
		locale =  "zh-HK";

	var translated = data.days + " " + data.hours + ":" + data.minutes;
	if(dayOfMonth !== "*" && month !== "*"){
		date = new Date(new Date().getFullYear(), month, dayOfMonth);
		translated = date.toLocaleDateString(locale, options) + " " + data.hours + ":" + data.minutes;
	}
	return translated;
}

function sort_sched(a, b) {
	var x = reverse(a.cron);
	var y = reverse(b.cron);
	if (x < y) return -1;
	if (x > y) return 1;
	return 0;
}

function reverse(s) {
	console.log("The Ess: ", s);
	return s.split(" ")
		.map(fill)
		.reverse()
		.join(" ");
}

function fill(item) {
	if (item !== "*" && item.length < 2) {
		return "0" + item;
	} else {
		return item;
	}
}

/**
 * Just takes the 'readable' entry sent from UI and finds it's index.  It then
 * looks up the entry of same index in _sorted ie. the cron formatted version of
 * the same entry and returns that.
 */
function translate_to_cron(schedule) {
	var searching = schedule;
	var task = this.data.readable.reduce(function (searchIndex, item, index) {
		if (item.schedule === searching) searchIndex = index;
		return searchIndex;
	}, null);
	if (task === null) console.log("Schedule task does not exist!");
	return this._sorted[task].cron;
}
